import { Collapsible as CollapsiblePrimitive } from "radix-ui";

type AccordionRootProps = CollapsiblePrimitive.CollapsibleProps;

const AccordionRoot = CollapsiblePrimitive.Root;

export { AccordionRoot, type AccordionRootProps };
